import React from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import AdminDashboard from "./dashboard/AdminDashboard";
import Chats from "./chats";
import PaymentChat from "./paymentChats";
import SubmittedArticle from "./submittedArticle";
import ClientArticle from "./clientArticle";
import SingleArticle from "./clientArticle/single";
import SingleSubmittedArticle from "./submittedArticle/single";
import Clients from "./clients";
import SideBar from "./adminComponents/SideBar";
import Header from "./adminComponents/Header";
import Category from "./category";
import Journal from "./journal";
import Users from "./users";
import Notification from "./Notification/Notification";
import NotFound from "../../commonComponents/Notfound";
import Calculation from "../../commonComponents/calculation/calculation";
import Handler from "./adminComponents/Handler";
import RefundList from "./refunds";

const AdminRoutes = () => {
  return (
    <div className="main_components d-flex">
      <SideBar />
      <div className="rightPanel">
        <Header />
        <Routes>
          <Route path={`/`} element={<Navigate to="/admin/dashboard" />} />
          <Route path={`/dashboard`} element={<AdminDashboard />} />
          {/* <Route path={`/`} element={<ClientArticle />} /> */}
          {/* <Route path={`/chat-list`} element={<Chats />} /> */}
          <Route path={`/calculation`} element={<Calculation />} />

          {/* <Route path={`/payment-chat`} element={<PaymentChat />} /> */}
          <Route path={`/client-articles`} element={<ClientArticle />} />
          <Route path={`/single-article/:id`} element={<SingleArticle />} />
          <Route path={`/articles`} element={<SubmittedArticle />} />
          <Route path={`/handler`} element={<Handler />} />
          <Route
            path={`/submitted-article/:id`}
            element={<SingleSubmittedArticle />}
          />
          <Route path={`/client`} element={<Clients />} />
          {/* <Route path={`/category`} element={<Category/>} /> */}
          <Route path={`/publication`} element={<Journal />} />
          <Route path={`/user`} element={<Users />} />
          <Route path={`/refunds`} element={<RefundList />} />

          <Route path={`/*`} element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminRoutes;
